// extracted by mini-css-extract-plugin
export const root = "image-slider-module--root--2vjNZ";
export const slider = "image-slider-module--slider--3T_L2";